<template>
  <div>
    <div class="columns">
      <page-header
        title="Cumplimiento por horario por tipo de entrega"
      ></page-header>
    </div>
    <filtros @change="changeFiltersHandle"></filtros>
    <section>
      <div class="columns">
        <div class="column is-2">
          <b-field label="Zona">
            <b-select
              v-model="zona"
              placeholder="Seleccione una zona..."
              expanded
            >
              <option
                v-for="item in zonas"
                :key="`zona-${item.id}`"
                :value="item.id"
              >
                {{ item.nombre }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <table>
            <tr>
              <th colspan="2"></th>
              <th class="center header" colspan="4">Promedio de tiempos</th>
              <th></th>
              <th class="th-gap" colspan="1"></th>
              <th class="center header" :colspan="titulos.length">
                Disponibilidad Inicio Horario
              </th>
            </tr>
            <tr>
              <th class="center header" style="width: 10%">Horario</th>
              <th class="center header" style="width: 9%">Cant. OV</th>
              <th class="center header" style="width: 9%">Asignaci&oacute;n</th>
              <th class="center header" style="width: 9%">Picking</th>
              <th class="center header" style="width: 9%">Despacho</th>
              <th class="center header" style="width: 9%">Total</th>
              <th class="center header" style="width: 10%">
                Bajo T&deg; Asegurado
              </th>
              <th class="th-gap"></th>
              <th
                v-for="(key, index) in titulos"
                :key="`titulo-disponibilidad-${index}`"
                class="center header"
              >
                {{ key }}
              </th>
            </tr>
            <tr
              v-for="(item, index) in horarios"
              :key="`horarios-line-${index}`"
            >
              <td class="center">{{ item.horario }}</td>
              <td class="right">{{ item.cantidadOV }}</td>
              <td class="center">{{ item.asignacion }}</td>
              <td class="center">{{ item.picking }}</td>
              <td class="center">{{ item.despacho }}</td>
              <td class="center">
                <b-tag :type="item.colorTiempoPromedio">
                  {{ item.total }}
                </b-tag>
              </td>
              <td class="center">
                <b-tag :type="item.colorTiempoMaximo">
                  {{ item.cumplimientoTiempoMaximo }}
                </b-tag>
              </td>
              <td class="td-gap"></td>
              <td
                v-for="(cell, y) in disponibilidad[index]"
                :key="`horarios-line-${index}-${y}`"
                class="center"
              >
                {{ cell }}
              </td>
            </tr>
            <tr v-if="horarios.length === 0">
              <td colspan="10"><strong>No se han cargado datos!</strong></td>
            </tr>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { dashboardService, zonaService } from '@/services'
import Filtros from '@/components/dashboard/Filtros.vue'
import PageHeader from '@/components/shared/PageHeader.vue'

export default {
  name: 'TiemposPorZona',
  components: {
    Filtros,
    PageHeader
  },
  data() {
    return {
      desde: null,
      hasta: null,
      horarios: [],
      disponibilidad: [],
      zonas: [],
      zona: null,
      timer: null
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    titulos() {
      const titulos = []
      for (const item in this.disponibilidad[0] || {}) {
        titulos.push(item)
      }
      return titulos
    }
  },
  watch: {
    zona() {
      this.getDashboardData()
    }
  },
  beforeDestroy() {
    this.removeTimer()
  },
  mounted() {
    this.getZonas().then((_) => {
      this.zona = this.zonas[0].id
    })
    this.getDisponibilidadPorHora()
  },
  methods: {
    changeFiltersHandle(payload) {
      this.desde = payload.desde
      this.hasta = payload.hasta
      this.getDashboardData()
      this.getDisponibilidadPorHora()
    },
    async getDashboardData() {
      try {
        if (!this.zona) return
        const parametros = { zona: this.zona }
        if (!this.desde || !this.hasta) {
          this.desde = new Date()
          this.hasta = new Date()
        }
        this.removeTimer()
        const rs = await dashboardService.getDashboardDataset(
          2,
          this.bodega.id,
          this.desde,
          this.hasta,
          parametros
        )
        this.horarios = rs.data
        this.timer = setInterval(() => this.getDashboardData(), 60000)
      } catch (e) {
        this.procesarError(e)
      }
    },
    removeTimer() {
      if (this.timer !== null) clearInterval(this.timer)
    },
    async getZonas() {
      await zonaService
        .getZonasByBodega(this.bodega.id)
        .then((response) => (this.zonas = response.data))
    },
    async getDisponibilidadPorHora() {
      try {
        if (!this.desde || !this.hasta) {
          this.desde = new Date()
          this.hasta = new Date()
        }
        const rs = await dashboardService.getDashboardDataset(
          3,
          this.bodega.id,
          this.desde,
          this.hasta
        )
        this.disponibilidad = rs.data
      } catch (_) {
        return 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
}

.right {
  text-align: right;
}

table {
  th.header,
  td {
    border: 1px solid #000;
    padding: 2px 6px;
  }
  td.td-gap {
    border-top: none;
    border-bottom: none;
    &:last-child {
      border-right: none;
    }
  }
}
</style>
